import { restaurantProductsStockUpdate } from "../actions";

import { Box, Icon, Stack, Typography } from "@mui/material";
import useRequest from "api/useRequest";
import { modalHide } from "app/App/actions";
import { AxiosResponse } from "axios";
import trans from "helpers/trans";
import { FC, useRef } from "react";
import { useDispatch } from "react-redux";
import {
    Form,
    LoadingButton,
    Modal,
    ModalActions,
    ModalContent,
    ModalTitle,
    NumberField,
    RequestMessage,
    Settings,
    SettingsItem,
    TextField,
} from "ui";
import { IGPFormRef } from "ui/Form/Form";

type ModifyStockModalProps = {
    id: string;
    productId: number;
    productName: string;
    reload: () => void;
    stock: number;
};

const ModifyStockModal: FC<ModifyStockModalProps> = ({
    id,
    productId,
    productName,
    reload,
    stock,
}) => {
    const { errors, isLoading, request, isError, message } = useRequest();
    const formRef = useRef<IGPFormRef | null>();
    const dispatch = useDispatch();

    const handleStore = () => {
        if (formRef.current !== null) handleSubmit(formRef?.current?.getData());
    };
    const handleCloseModal = () => dispatch(modalHide(id));

    const handleSubmit = (data: any) => {
        request(
            restaurantProductsStockUpdate(
                productId,
                data,
                (response: AxiosResponse) => {
                    if (response.status === 204) {
                        reload();
                        dispatch(modalHide(id));
                    }
                }
            )
        );
    };

    return (
        <Modal maxWidth="md" fullWidth open>
            <ModalTitle onClose={handleCloseModal}>{productName}</ModalTitle>
            <ModalContent sx={{ display: "flex", flexDirection: "column" }}>
                {isError && message && (
                    <Box sx={{ mb: 2 }}>
                        <RequestMessage status={400} message={message} />
                    </Box>
                )}
                <Typography sx={{ mb: 2 }}>
                    {trans(
                        "inv.restaurantProducts.modal.ModifyStockModal.currentStock",
                        { stock }
                    )}
                </Typography>
                <Form
                    ref={formRef}
                    data={{ stock: "", reason: "" }}
                    errors={errors}
                    fields={{
                        stock: {},
                        reason: {},
                    }}
                    loading={isLoading}
                    onSubmit={handleSubmit}
                    unsaved={false}
                >
                    <Settings>
                        <SettingsItem
                            label={trans(
                                "inv.restaurantProducts.modal.ModifyStockModal.label"
                            )}
                        >
                            <NumberField id="stock" fullWidth autoFocus />
                        </SettingsItem>
                        <SettingsItem
                            label={trans(
                                "inv.restaurantProducts.modal.ModifyStockModal.reason"
                            )}
                        >
                            <TextField id="reason" fullWidth />
                        </SettingsItem>
                    </Settings>
                </Form>
            </ModalContent>
            <ModalActions
                sx={{
                    flexDirection: "column",
                    justifyContent: "center",
                    p: 0,
                }}
            >
                <Stack
                    direction="row"
                    sx={{
                        backgroundColor: "grey.200",
                        marginLeft: "0!important",
                        p: 1,
                        width: "100%",
                    }}
                >
                    <LoadingButton
                        loading={isLoading}
                        loadingPosition="start"
                        fullWidth
                        onClick={handleStore}
                        startIcon={<Icon>save</Icon>}
                    >
                        {trans("global.button.save")}
                    </LoadingButton>
                </Stack>
            </ModalActions>
        </Modal>
    );
};

export default ModifyStockModal;
